module.exports = __webpack_public_path__ + "0459d490b8fc8526a6b5dbbad6dae8f0.png";